import { createBrowserRouter } from 'react-router';
import { RootLayout } from '@/layouts/RootLayout';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { HomePage } from '@/pages/HomePage';
import { AccountsRedirectPage } from '@/pages/accounts/AccountsRedirectPage';
import { AccountDetailPage } from '@/pages/accounts/AccountDetailPage';
import { DocsPage } from '@/pages/DocsPage';
import { SignInPage } from '@/pages/auth/SignInPage';
import { AuthErrorPage } from '@/pages/auth/AuthErrorPage';
import { CallbackPage } from '@/pages/auth/CallbackPage';
import { DebugConfigPage } from '@/pages/debug/DebugConfigPage';
import { CompaniesPage } from '@/pages/mise/CompaniesPage';
import { CreateCompanyPage } from '@/pages/mise/CreateCompanyPage';
import { CompanyDetailPage } from '@/pages/mise/CompanyDetailPage';
import { AccountDetailPage as MiseAccountDetailPage } from '@/pages/mise/AccountDetailPage';
import { UsagePage } from '@/pages/mise/UsagePage';
import { LlmCostPage } from '@/pages/mise/LlmCostPage';
import { InquiriesPage } from '@/pages/mise/InquiriesPage';
import { InquiryDetailPage } from '@/pages/mise/InquiryDetailPage';
import { PredictionErrorEvaluationPage } from '@/pages/ds/PredictionErrorEvaluationPage';
import { McpUsagePage } from '@/pages/McpUsagePage';
import { UsageAggregationPage } from '@/pages/UsageAggregationPage';
import { ConsumptionDetailPage } from '@/pages/credit/ConsumptionDetailPage';
import { ConsumptionListPage } from '@/pages/credit/ConsumptionListPage';
import { ContractDetailPage } from '@/pages/credit/ContractDetailPage';
import { ContractListPage } from '@/pages/credit/ContractListPage';
import { ConversionSettingsPage } from '@/pages/credit/ConversionSettingsPage';
import { CustomDashboardPage } from '@/pages/CustomDashboardPage';
import { DashboardLlmCostPage } from '@/pages/DashboardLlmCostPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'accounts',
        element: (
          <ProtectedRoute>
            <AccountsRedirectPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'accounts/:id',
        element: (
          <ProtectedRoute>
            <AccountDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'docs',
        element: (
          <ProtectedRoute>
            <DocsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'debug/config',
        element: (
          <ProtectedRoute>
            <DebugConfigPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'mise/companies',
        element: (
          <ProtectedRoute>
            <CompaniesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'mise/companies/new',
        element: (
          <ProtectedRoute>
            <CreateCompanyPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'mise/companies/:id',
        element: (
          <ProtectedRoute>
            <CompanyDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'mise/usage',
        element: (
          <ProtectedRoute>
            <UsagePage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'mise/llm-cost',
        element: (
          <ProtectedRoute>
            <LlmCostPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'mise/inquiries',
        element: (
          <ProtectedRoute>
            <InquiriesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'mise/inquiries/:id',
        element: (
          <ProtectedRoute>
            <InquiryDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'mise/accounts/:id',
        element: (
          <ProtectedRoute>
            <MiseAccountDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'ds/prediction-error-evaluation',
        element: (
          <ProtectedRoute>
            <PredictionErrorEvaluationPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'ai/mcp-usage',
        element: (
          <ProtectedRoute>
            <McpUsagePage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'usage-aggregation',
        element: (
          <ProtectedRoute>
            <UsageAggregationPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'credit/consumption',
        element: (
          <ProtectedRoute>
            <ConsumptionListPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'credit/consumption/:companyId',
        element: (
          <ProtectedRoute>
            <ConsumptionDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'credit/contracts',
        element: (
          <ProtectedRoute>
            <ContractListPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'credit/contracts/:companyId',
        element: (
          <ProtectedRoute>
            <ContractDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'credit/conversion-settings',
        element: (
          <ProtectedRoute>
            <ConversionSettingsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'custom-dashboard',
        element: (
          <ProtectedRoute>
            <CustomDashboardPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'dashboard/llm-cost',
        element: (
          <ProtectedRoute>
            <DashboardLlmCostPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '/auth',
    element: <RootLayout />,
    children: [
      {
        path: 'signin',
        element: <SignInPage />,
      },
      {
        path: 'error',
        element: <AuthErrorPage />,
      },
      {
        path: 'callback',
        element: <CallbackPage />,
      },
    ],
  },
]);
